/**
 * Interpolation types for image rendering
 */
enum InterpolationType {
  /** nearest neighbor interpolation */
  NEAREST,
  /** linear interpolation - Default */
  LINEAR,
  /** */
  FAST_LINEAR,
}

export default InterpolationType;
